import addWeeks from 'date-fns/addWeeks';

export function getWeeksAdded(date, weeks = 2) {
  return addWeeks(date, weeks);
}
